module.exports = __webpack_public_path__ + "img/mecanica1.ee6e320a.jpg";